var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"scrollToTop",on:{"click":_vm.scrollToTop}},[_c('b-icon',{attrs:{"icon":"chevron-up"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }